import { decode, getSanitised, isEmpty } from '../../../helpers/utils'

export const formatFilterValues = (filters, isPrice) => {
  return filters.map((filter) => {
    const priceValue = filter.values.includes('%25') ? getSanitised(filter.values) : filter.values
    const filterValue = isPrice ? priceValue : decode(filter.values)

    return {
      ...filter,
      values: filterValue.toLowerCase()
    }
  })
}

export const appliedFilterNames = (filterObject) => {
  return Object.keys(filterObject).filter((filterName) => filterObject[filterName].length > 0)
}

export const filterString = (filterName, filterValue) => `filter=${filterName}:${filterValue}`

export const filterValueTest = (dataId, filterValues) => {
  // here the regExPattern turns the aggregation id into a regEx and then we test the filterValues against this.
  // this means if the filterValue contains all the words in the aggregation id, this test will return true.
  // we could however get false matches if the filterValue contains the aggregation id along with some invalid data. Exmaple: if dataId = "king-size" and filterValues = "king-sizeabc", this will return a match
  const regExPattern = new RegExp(dataId?.replaceAll?.(/[^a-z0-9]/g, '.+'))

  return regExPattern.test(filterValues)
}

export const aggregationIdMatcher = (aggregationResults, filterType, filterValues) => {
  const filterAggregations = aggregationResults.filter((filter) => filter.id !== 'price' && filter.id === filterType)
  const matchedAggregation = filterAggregations[0]?.values.find(
    (aggregation) => filterValueTest(aggregation.id, filterValues) && aggregation.value > 0
  )
  // if there are no aggregations for the current filter type, return true, which means show all the filters anyway
  // if there are aggregations, loop through them and find if any match the filterValue, if matches check if the number of products associated with it is greater than 0
  return filterAggregations.length === 0 || (matchedAggregation && !isEmpty(matchedAggregation))
}
